import Business from "../components/Business";
import Footer from '../components/Footer';
import Slider from '../components/LandingPageScroll';
import PortfolioScroll from '../components/PScroll';
import styles from "../style";
import FeatureCard from "../components/FeatureCard";
import { features } from "../constants";
import { img2 } from "../assets/index.js";
import Provide from "../components/Provide";

const Home = () => {
  
  return (
    <div className="bg-primary w-full items-center flex flex-col">     
      <Slider />
      <div 
        style={{ 
          backgroundImage: `url(${img2})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          zIndex: 0,
        }} 
        className={`w-full py-10 relative overflow-hidden`}
      > 
        <Provide />
        <div className="w-full gradient-04 z-0" />            
        <Business />
        <div className="w-full gradient-02 z-0" />
        <FeatureCard features={features} />
      </div>      
      <PortfolioScroll />    
      <Footer/>       
    </div>
  )
} 
export default Home;